import React, { Component } from "react";

// Router
import { withRouter } from "react-router-dom";

//Redux
import { connect } from "react-redux";
import { getFunderProfile } from "../../../redux/actions/funders";

// Ajax Methods
import ajaxMethods from "../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../api/ajax-endpoints";

import "./ProductModal.css";

import { currency } from "../../../helpers/stringControllers";
import { appInsights } from "../../../config/appInsights";

class FunderProductModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scene: "form",
      productCategoryOptions: [],
      aggregatorProductsOptions: [],
      aggregatorOptions: [],
      funderOptions: [],
      selectedAggregatorId: props?.properties?.dataRecord?.aggregator_id || "",
      selectedFunderId: props?.properties?.dataRecord?.funder_id || "",
      selectedProductId: props?.properties?.dataRecord?.id || "",
      selectedMappingId: props?.properties?.dataRecord?.mapping_id || "",
      amount: props?.properties?.dataRecord?.amount || "",
      showMessage: false,
      showErrorMessage: false,
      showWarningMessage: true,
      disableProducts: true,
      message: "Select Aggregator to view products",
      funderProfile: {
        profile: null,
      },
    };
  }

  componentDidMount() {
    if (this.props.properties.dataRecord) {
      this.setState({ showWarningMessage: false });
      this.getAggregatorProducts(
        this.props.properties.dataRecord.aggregator_id
      );
    }
    if (!this.props.funderUi) {
      this.getFunderName();
    } else {
      this.props.getFunderProfile();
    }
    this.getAggregatorName();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.funderProfile) {
      if (nextProps.funderProfile.profile !== prevState.funderProfile.profile) {
        return { selectedFunderId: nextProps.funderProfile.profile.funder_id };
      }
    }
  }

  //fetch all funders
  getFunderName = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_ALL_FUNDERS)
      .then((response) => {
        let funderList = [];

        if (response.data.length > 0) {
          funderList = [...response.data];
        } else {
          funderList = [
            {
              funder_id: 0,
            },
          ];
        }
        const funderOptions = funderList.map((funder, index) => {
          const { funder_id, funder_name } = funder;
          return (
            <option key={index} id={funder_id} value={funder_id}>
              {funder_name}
            </option>
          );
        });

        this.setState({
          funderOptions: funderOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "FundsProductModal.js",
          },
        });
      });
  };

  //fetch aggregators
  getAggregatorName = () => {
    ajaxMethods
      .get(ajaxEndpoints.ECOSYSTEMS)
      .then((response) => {
        let categoryList = [];

        if (response.data.length > 0) {
          categoryList = [...response.data];
        } else {
          categoryList = [
            {
              aggregator_id: 0,
              biz_name: "No Aggregators Found",
              biz_slug: "No Aggregators Found",
            },
          ];
        }

        const aggregatorOptions = categoryList.map((ecosystem, index) => {
          const { aggregator_id, biz_name } = ecosystem;
          return (
            <option key={index} id={aggregator_id} value={aggregator_id}>
              {biz_name}
            </option>
          );
        });

        this.setState({
          aggregatorOptions: aggregatorOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "FundsProductModal.js",
          },
        });
      });
  };

  getAggregatorProducts = (aggr_id) => {
    this.setState({ disableProducts: true });
    ajaxMethods
      .get(
        ajaxEndpoints.GET_ALL_AGGREGATORS_PRODUCT + `?aggregator_id=${aggr_id}`
      )
      .then((response) => {
        let aggregatorProductsList = [];
        if (response) {
          if (response.data.length > 0) {
            aggregatorProductsList = [...response.data];
            this.setState({ disableProducts: false });
          }
        } else {
          aggregatorProductsList = [
            {
              id: 0,
              product_name: "No products found",
              product_slug: "No products found",
            },
          ];
          this.setState({ disableProducts: false });
        }

        const aggregatorProductsOptions = aggregatorProductsList.map(
          (product, index) => {
            const { id, product_name } = product;
            return (
              <option key={index} id={id} value={id}>
                {product_name}
              </option>
            );
          }
        );

        this.setState({
          aggregatorProductsOptions: aggregatorProductsOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "FundsProductModal.js",
          },
        });
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      selectedFunderId,
      selectedProductId,
      selectedAggregatorId,
      amount,
    } = this.state;

    const { funderUi } = this.props;

    const data = {
      product_id: parseInt(selectedProductId),
      funders: [
        {
          funder_id: parseInt(selectedFunderId),
          amount: parseFloat(amount),
        },
      ],
    };

    let isValid = true;
    if (
      selectedProductId === "" ||
      selectedProductId === "Select a Product" ||
      selectedProductId === "0"
    ) {
      this.setState({
        showErrorMessage: true,
        message: "Please select a product",
      });
      isValid = false;
    }
    if (
      selectedAggregatorId === "" ||
      selectedAggregatorId === "Select Aggregator" ||
      selectedAggregatorId === "No Aggregators Found"
    ) {
      this.setState({
        showErrorMessage: true,
        message: "Please select an aggregator",
      });
      isValid = false;
    }
    if (
      (selectedFunderId === "" && !funderUi) ||
      (selectedFunderId === "Select Funder" && !funderUi) ||
      (selectedFunderId === "0" && !funderUi)
    ) {
      this.setState({
        showErrorMessage: true,
        message: "Please select a funder",
      });
      isValid = false;
    }
    if (amount === "" || amount === 0) {
      this.setState({
        showErrorMessage: true,
        message: "Please enter an amount",
      });
      isValid = false;
    }

    if (isValid) {
      ajaxMethods
        .post(ajaxEndpoints.CREATE_FUNDERS_PRODUCT, data)
        .then((response) => {
          let message = "";
          if (response.status === 200 || response.status === 201) {
            message = response.data.message;
            this.setState({
              message: message,
              showMessage: true,
              selectedFunderId: "",
              selectedProductId: "",
              amount: "",
              selectedAggregatorId: "",
            });
            // this.props.getFundersProduct();
            return;
          } else if (response.status === 400) {
            message = response.data.message;
            return this.setState({ message: message, showErrorMessage: true });
          } else {
            message = "Unable to connect to Advancly services";
            return this.setState({ message: message, showErrorMessage: true });
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "FundsProductModal.js",
            },
          });
        });
    }
  };

  handleEdit = (e) => {
    e.preventDefault();
    const {
      selectedFunderId,
      selectedProductId,
      selectedAggregatorId,
      selectedMappingId,
      amount,
    } = this.state;

    const data = {
      mapping_id: parseInt(selectedMappingId),
      product_id: parseInt(selectedProductId),
      funders: [
        {
          funder_id: parseInt(selectedFunderId),
          amount: parseFloat(amount),
        },
      ],
    };

    let isValid = true;
    if (selectedProductId === "Select a Product" || selectedProductId === "0") {
      this.setState({
        showErrorMessage: true,
        message: "Please select a product",
      });
      isValid = false;
    }
    if (
      selectedAggregatorId === "Select Aggregator" ||
      selectedAggregatorId === "No Aggregators Found"
    ) {
      this.setState({
        showErrorMessage: true,
        message: "Please select an aggregator",
      });
      isValid = false;
    }
    if (amount === "" || amount === 0) {
      this.setState({
        showErrorMessage: true,
        message: "Please enter an amount",
      });
      isValid = false;
    }

    if (isValid) {
      ajaxMethods
        .post(ajaxEndpoints.EDIT_FUNDERS_PRODUCT, data)
        .then((response) => {
          let message = "";
          if (response.status === 200 || response.status === 201) {
            message = response.data.message;
            return this.setState({ message: message, showMessage: true });
          } else if (response.status === 400) {
            message = response.data.message;
            return this.setState({ message: message, showErrorMessage: true });
          } else {
            message = "Unable to connect to Advancly services";
            return this.setState({ message: message, showErrorMessage: true });
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "FundsProductModal.js",
            },
          });
          let message = "Unable to connect to Advancly services";
          return this.setState({ message: message, showErrorMessage: true });
        });
    }
  };

  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      showMessage: false,
      showErrorMessage: false,
      showWarningMessage: false,
      message: "",
    });
    if (e.target.name === "selectedAggregatorId") {
      this.getAggregatorProducts(e.target.value);
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      showMessage: false,
      showErrorMessage: false,
    });
  };

  render() {
    const {
      scene,
      funderOptions,
      aggregatorOptions,
      aggregatorProductsOptions,
      selectedAggregatorId,
      selectedFunderId,
      selectedProductId,
      amount,
      showMessage,
      showErrorMessage,
      showWarningMessage,
      disableProducts,
      message,
    } = this.state;

    const { properties, funderUi, funderProfile } = this.props;
    const { dataRecord } = properties;

    return (
      <div className="Modal__dialog animated slideInDown" role="document">
        <div
          className="IssueModal Modal__content"
          style={{ overflow: "hidden" }}
        >
          <div className="Modal__body">
            <h3
              className="Modal__title m-b-1 p-x-2 p-y-1 "
              style={{ backgroundColor: "#713fff", color: "#fff" }}
            >
              {this.props.properties.dataRecord && <span>Edit</span>} Funder's
              Products
            </h3>
            {/* Product Form */}
            {(() => {
              switch (scene) {
                case "form":
                  return (
                    <form>
                      <div className="row">
                        <div className="col-xs-6">
                          <label className="label-txt">Funder</label>
                          <div className="form-group inputWithIcon">
                            {dataRecord && !funderUi && (
                              <input
                                className="user__form form-control"
                                readOnly={true}
                                value={dataRecord.funder_name}
                              />
                            )}
                            {funderUi && (
                              <input
                                className="user__form form-control"
                                readOnly={true}
                                value={
                                  funderProfile.profile
                                    ? funderProfile.profile.funder_name
                                    : ""
                                }
                              />
                            )}
                            {!dataRecord && !funderUi && (
                              <select
                                className="round user__form form-control"
                                name="selectedFunderId"
                                placeholder="Select Funder"
                                id="selectedFunderId"
                                value={selectedFunderId}
                                onChange={(e) => this.handleOptionSelect(e)}
                              >
                                <option defaultValue>Select Funder</option>
                                {funderOptions}
                              </select>
                            )}
                            <i className="adv-aggregator-icon fas fa-building"></i>{" "}
                          </div>
                        </div>

                        <div className="col-xs-6">
                          <label className="label-txt">Aggregator</label>
                          <div className="form-group inputWithIcon">
                            <select
                              className="round user__form form-control"
                              name="selectedAggregatorId"
                              placeholder="Select Aggregator"
                              id="selectedAggregatorId"
                              value={selectedAggregatorId}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option defaultValue>Select Aggregator</option>
                              {aggregatorOptions}
                            </select>
                            <i className="adv-aggregator-icon fas fa-building"></i>{" "}
                          </div>
                        </div>
                      </div>

                      <div className="row m-t-1">
                        <div className="col-xs-6">
                          <label className="label-txt">Product</label>
                          <div className="form-group inputWithIcon">
                            {/* {disableProducts ?
                              <input
                                className="user__form form-control"
                                readOnly={true}
                                value="Select an aggregator"
                              />
                              : */}
                            <select
                              className="round user__form form-control"
                              name="selectedProductId"
                              placeholder="Select a Product"
                              id="selectedProductId"
                              value={selectedProductId}
                              disabled={disableProducts}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option defaultValue>Select a Product</option>
                              {aggregatorProductsOptions}
                            </select>
                            {/* } */}
                            <i className="adv-aggregator-icon fas fa-university"></i>{" "}
                          </div>
                        </div>

                        <div className="col-xs-6">
                          <label className="label-txt">
                            Amount {currency(amount)}
                          </label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="user__form form-control"
                              data-form="amount"
                              name="amount"
                              placeholder="0.00"
                              value={amount}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-money"></i>{" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-xs-6 m-t-2">
                        {showMessage && (
                          <span className="text-success p-b-2">{message}</span>
                        )}
                        {showErrorMessage && (
                          <span className="text-danger p-b-2">{message}</span>
                        )}
                        {showWarningMessage && (
                          <span className="text-warning p-b-2">{message}</span>
                        )}

                        <div className="grid__full">
                          {!this.props.properties.dataRecord && (
                            <button
                              type="submit"
                              className="zoom-element btn login-btn"
                              onClick={this.handleSubmit}
                            >
                              &nbsp; Submit
                            </button>
                          )}
                          {this.props.properties.dataRecord && (
                            <button
                              type="submit"
                              className="zoom-element btn login-btn"
                              onClick={this.handleEdit}
                            >
                              &nbsp; Update
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  );

                default:
                  return null;
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ fundersReducer: { funderProfile } }) => {
  return {
    funderProfile,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getFunderProfile,
  })(FunderProductModal)
);
